module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pl-2b5541c54505328dbc1b264a72369d23.svg";